<div class="h-100 box p-5 relative">
    <div class="icon icon-xxxl icon-default mb-5 mx-auto d-block" inlineSVG="assets/icons.svg#content-{{ episode.media }}"></div>

    <div class="text-center text-line-3">
        <div class="font-semi-bold mb-5">
            {{ 'v3-byoc-popup-create-episode-recommend-titel-1' | translate }} <span class="font-bold">{{ episode.name }}</span>
            {{
                hasNoUsersAffected
                    ? ('v3-byoc-popup-create-episode-recommend-titel-no-users-2' | translate)
                    : ('v3-byoc-popup-create-episode-recommend-titel-2' | translate: { x: affectedUsersCount })
            }}
        </div>
    </div>

    <div class="theme-new d-flex justify-content-center px-4">
        <button
            *ngIf="hasAccessToAllContent; else goToCustomContentButton"
            (click)="goToCourse()"
            class="btn btn-secondary"
            buttonDataTest="viewCourseButton"
            translate
        >
            v3-explore-view-course-btn
        </button>
    </div>
</div>

<ng-template #goToCustomContentButton>
    <button (click)="goToCustomContent()" buttonDataTest="okButton" class="btn btn-secondary" translate>OK</button>
</ng-template>
